module.exports = "<div class=\"wrapper\">\n    <!-- top navbar-->\n    <app-header class=\"topnavbar-wrapper\"></app-header>\n    <!-- sidebar-->\n    <app-sidebar class=\"aside\"></app-sidebar>\n    <!-- offsidebar-->\n    <app-offsidebar class=\"offsidebar\"></app-offsidebar>\n    <!-- Main section-->\n    <section>\n        <!-- Page content-->\n        <div class=\"content-wrapper\">\n            <router-outlet></router-outlet>\n        </div>\n    </section>\n    <!-- Page footer-->\n    <footer app-footer></footer>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/uber-admin-layout/uber-admin-layout.component.html
// module id = 1218
// module chunks = 7